import { render, staticRenderFns } from "./disposiciones.vue?vue&type=template&id=e60f5930"
import script from "./disposiciones.vue?vue&type=script&lang=js"
export * from "./disposiciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports